import { Gallery } from '../gallery/gallery';
import { Overlay } from '../overlay/overlay';


// eslint-disable-next-line import/prefer-default-export
export class KSUtility {
    static async showProductOverlay(url, id) {
        // eslint-disable-next-line no-console

        if (!$(`#productOverlay-${id}`).length) {
            await $.get(url, (data) => {
                if (data.trim() !== '') {
                    $('body').prepend(data);

                    const gallery = $(`#productOverlay-${id}`).find('.gallery');
                    Gallery.initLater(gallery);
                    const overlay = $('.overlay--product');
                    Overlay.initLater(overlay);
                }
            });
        }

        $(`#productOverlay-${id}`).addClass('overlay--visible');
        $('html').addClass('body--no-scroll');
    }

    static initContactApp(speciality, tabIndex, prefilledSpeciality) {
        window.dispatchEvent(new CustomEvent('ContactAppInit', { detail: { initialTabIndex: tabIndex, speciality, prefilledSpeciality } }));
        const overlay = $('*[data-overlay-id="contact"]');
        Overlay.initLater(overlay);
    }
}

window.KSUtility = KSUtility;
